import PdfProductImage from '@/components/pdf/PdfProductImage';
import { PdfTableCell } from '@/components/pdf/PdfTableCell';
import { styles } from '@/components/pdf/styles';
import { usePrintCurrencyString } from '@/utils/price';
import { Text, View } from '@react-pdf/renderer';
import { FunctionComponent } from 'react';
import { PurchaseOrderCompleteDocumentTableData } from './PurchaseOrderCompleteDocumentTable';
import {
  PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_NAME_CELL_WIDTH,
  PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_PRICE_CELL_WIDTH,
  PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_QTY_CELL_WIDTH,
  PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_WARRANTY_CELL_WIDTH
} from './consts';

interface Props {
  data: PurchaseOrderCompleteDocumentTableData;
  regionCode?: string;
}

const PurchaseOrderCompleteDocumentTableRow: FunctionComponent<Props> = ({ data, regionCode }) => {
  const printCurrencyString = usePrintCurrencyString({ regionCode });
  const formattedPrice = printCurrencyString(data.price);
  const formattedTotalPrice = printCurrencyString(data.totalPrice);

  const specs = data.product.propertyBag.properties
    .filter(spec => spec.iconId?.toLowerCase() !== 'warranty')
    .map(spec => spec.text)
    .join(' | ');
  const warrantySpec = data.product.propertyBag.properties
    .filter(spec => spec.iconId?.toLowerCase() === 'warranty')
    .map(spec => spec.text);

  return (
    <View style={styles.tableRow}>
      <PdfTableCell height={40} width={PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_NAME_CELL_WIDTH}>
        <PdfProductImage product={data.product} />
        <View
          style={{
            height: 40,
            flex: 1,
            borderRightWidth: 0.5,
            borderStyle: 'solid',
            opacity: 1
          }}
        />
        <View
          style={{
            flexDirection: 'column',
            ...styles.tableCell,
            textAlign: 'left',
            marginLeft: 3
          }}
        >
          <Text style={{ textAlign: 'left', marginBottom: 3 }}>{data.name}</Text>
          <Text style={{ textAlign: 'left' }}>{specs}</Text>
        </View>
      </PdfTableCell>
      <PdfTableCell width={PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_WARRANTY_CELL_WIDTH}>
        <Text style={styles.tableCell}>{warrantySpec}</Text>
      </PdfTableCell>
      <PdfTableCell width={PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_QTY_CELL_WIDTH}>
        <Text style={styles.tableCell}>{data.qty}</Text>
      </PdfTableCell>
      <PdfTableCell width={PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_PRICE_CELL_WIDTH}>
        <Text style={styles.tableCell}>{formattedPrice}</Text>
      </PdfTableCell>
      <PdfTableCell lastCell width={PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_PRICE_CELL_WIDTH}>
        <Text style={styles.tableCell}>{formattedTotalPrice}</Text>
      </PdfTableCell>
    </View>
  );
};

export default PurchaseOrderCompleteDocumentTableRow;
